<template>
  <teleport to="#app-notification">
    <topbar-notification
      v-if="moment().isSameOrBefore(untilDate, 'day')"
      :checkpoint="checkpoint.LIMIT_15K_BANNER"
    >
      <bg-text>
        O limite de R$ 15k para TED foi removido. Transações com valores maiores de R$ 15.000
        estarão disponíveis somente para a rotina de <a href="https://suporte.transfeera.com/resgate-seu-saldo/">resgate de saldo</a>.
      </bg-text>
    </topbar-notification>
  </teleport>
</template>

<script setup>
import TopbarNotification from '@/commons/components/presentational/TopbarNotification.vue';
import checkpoint from '@/commons/constants/checkpoint';
import { BgText } from '@transfeeradev/bridge';
import moment from '@transfeeradev/moment';

const untilDate = moment('2026-06-27');
</script>
